import * as TWEEN from '@tweenjs/tween.js';
import {
	Container,
} from 'pixi.js';

import Card from '../Sprites/Card.js';

export default class Cards extends Container {
	constructor(cards, deckSpriteSheet, deck, ...arg) {
		super(...arg);
		this.isDirty = 0;
		this.cardTouched = function () { };

		this.cardUIs = [];
		this.deck = deck;
		//tweenGroup
		this.tweenGroup = new TWEEN.Group();

		this.load(cards, deckSpriteSheet);
	}

	load(cards, deckSpriteSheet) {

		//create cards
		for (let i = 0; i < cards.length; i++) {
			const card = cards[i];
			const cardUI = new Card(card, deckSpriteSheet);
			cardUI.on('pointerdown', this.onCardTouched.bind(this));
			this.cardUIs.push(cardUI);
			this.addChild(cardUI);
			// // //add tween
			// cardUI.tween = new TWEEN.Tween(cardUI, this.tweenGroup);
			// cardUI.tween.easing(TWEEN.Easing.Exponential.Out);
		}
		//this.update();

	}

	getDeck(deck) {
		let path = 'images/Decks/PixaromaDeck_SpriteSheet.json';

		if (deck === 'PixaromaDeck') {
			path = 'images/Decks/PixaromaDeck_SpriteSheet.json';
		}

		if (deck === 'PirateDeck') {
			path = 'images/Decks/PirateDeck_SpriteSheet.json';
		}

		if (deck === 'LargeNumberDeck') {
			path = 'images/Decks/LargeNumberDeck_SpriteSheet.json';
		}

		if (deck === 'HalloweenDeck') {
			path = 'images/Decks/HalloweenDeck_SpriteSheet.json';
		}

		if (deck === 'MedievalDeck') {
			path = 'images/Decks/MedievalDeck_SpriteSheet.json';
		}

		if (deck === 'ClassicDeck') {
			path = 'images/Decks/ClassicDeck_SpriteSheet.json';
		}

		if (deck === 'FantasyDeck') {
			path = 'images/Decks/FantasyDeck_SpriteSheet.json';
		}

		if (deck === 'WildWestDeck') {
			path = 'images/Decks/WildWestDeck_SpriteSheet.json';
		}

		return path;
	}

	updateLayout() {
		if (!this.deck) {
			return;
		}

		const isDirty = false;

		return isDirty;

	}

	update(force) {

		let isDirty = false;
		if (force) {
			isDirty = true;
		}

		//create tweens if pile changed
		if (this.isdirtyCardsPos === true || force) {
			this.updateCardsPos(this.cards, this.layout);
		}

		const anyTweensUpdated = this.tweenGroup.update();
		if (anyTweensUpdated) {
			isDirty = true;
		}

		// //if tween has ended, force all cards to position 
		// if (!anyTweensUpdated) {
		//     for (let i = 0; i < this.cardUIs.length; i++) {
		//         let cardUI = this.cardUIs[i];
		//         if (cardUI) {
		//             //mark dirty if not all in place
		//             if (cardUI.x != cardUI.targetX || cardUI.y != cardUI.targetY) {
		//                 isDirty = true;
		//                 cardUI.x = cardUI.targetX;
		//                 cardUI.y = cardUI.targetY;
		//             }
		//         }
		//     }
		// }

		//// no tween - jump to location if pile changed
		// if (this.isdirtyCardsPos === true || force) {
		//     this.updateCardsPos(this.cards, this.layout);
		//     for (let i = 0; i < this.cardUIs.length; i++) {
		//         let cardUI = this.cardUIs[i];
		//         if (cardUI) {
		//             mark dirty if not all in place
		//             if (cardUI.x != cardUI.targetX || cardUI.y != cardUI.targetY) {
		//                 isDirty = true;
		//                 cardUI.x = cardUI.targetX;
		//                 cardUI.y = cardUI.targetY;
		//             }
		//         }
		//     }
		// }

		return isDirty;

	}

	onCardTouched(event) {
		// let cardId = event.currentTarget.id;
		//todo: make this trigger an event without having a refence to context
		// this.cribbage.action("play", cardId, "player1");
		if (this.cardTouched) {
			this.cardTouched(event);
		}

	}

	hasCardMoved() {
		return this.isdirtyCardsPos;
	}

	updateCards(cards, layout) {
		this.isdirtyCardsPos = true;
		this.cards = cards;
		this.layout = layout;
	}

	updateCardsPos(cards, layout) {
		//clear tweens (could remove tweens for cards being updated only)
		this.tweenGroup.removeAll();

		//copy all data needed form card models and be done with core game logic
		//get all cardUIs and update properties
		const cardUIs = [];
		for (const cardModel of cards) {

			//find card UI
			const cardUI = this.cardUIs.find(cUI => cUI.id === cardModel.id);
			if (!cardUI) {
				continue;
			} //todo: create new card for missing UI

			//update from model
			cardUI.pile = cardModel.pile; //update from model
			cardUI.showfront = cardModel.showfront; //todo: optimize updating texture only if needed
			cardUI.zIndex = cardModel.pilez || cardModel.order;
			cardUI.isSelected = cardModel.isSelected;
			cardUI.meld = cardModel.meld;
			cardUIs.push(cardUI);
		}

		//group in to piles 
		const piles = cardUIs.reduce(function (rv, x) {
			(rv[x.pile] = rv[x.pile] || []).push(x);
			return rv;
		}, {});

		for (const [pileName, pileCardUIs] of Object.entries(piles)) {

			//update based on pile layout
			if (typeof layout[pileName] !== 'undefined') {
				const pileLayout = layout[pileName];
				if (pileLayout !== undefined) {

					//if random order then randomize the order consistantly
					if (pileLayout.randomZOrder === true) {
						pileCardUIs.sort(function (a, b) {
							return a.randomId - b.randomId;
						}); //todo: optimize, this should not be called on ever card, but on each pile
						for (const cardUI of pileCardUIs) {
							cardUI.zIndex = pileCardUIs.indexOf(cardUI);
						}
					}

					//for all cards in pile
					for (const cardUI of pileCardUIs) {
						if (typeof pileLayout.showfront !== 'undefined') {
							cardUI.showfront = pileLayout.showfront;
						}

						if (typeof pileLayout.width !== 'undefined') {
							cardUI.width = pileLayout.width;
						}

						if (typeof pileLayout.height !== 'undefined') {
							cardUI.height = pileLayout.height;
						}

						if (typeof pileLayout.scale !== 'undefined') {
							cardUI.scale.x = cardUI.scale.y = pileLayout.scale || 1;
						}

						if (typeof pileLayout.offsetZ !== 'undefined') {
							cardUI.zIndex += pileLayout.offsetZ;
						}

						if (typeof pileLayout.visible !== 'undefined') {
							cardUI.visible = pileLayout.visible;
						}
					}

					switch (pileLayout.style) {
						case 'melds':
							{
								const pilecount = pileCardUIs.length;
								const pileX = pileLayout.x;
								const pileY = pileLayout.y;
								const cardWidth = pileLayout.width || 0;
								//let cardHeight = pileLayout.height;
								//let offsetX = pileLayout.offsetX;
								//let offsetY = pileLayout.offsetY;
								//let offsetR = pileLayout.offsetR;
								const pileWidth = pileLayout.pileWidth;
								let currentX = 0;
								let offsetX = 0;
								const offsetXMeld = 30;
								let lastCardMeld = false;
								pileCardUIs.sort(function (a, b) {
									return (a.zIndex || 0) - (b.zIndex || 0);
								});
								for (let i = 0; i < pilecount; i++) {//const cardUI of pileCardUIs) {
									const cardUI = pileCardUIs[i];
									const remainingWidth = pileWidth - cardWidth - currentX;
									const remainingCards = pilecount - i;

									offsetX = remainingWidth / remainingCards;
									//card after meld
									if (lastCardMeld === true) {
										offsetX = offsetXMeld;
									}

									lastCardMeld = false;
									if (cardUI.meld > 0) {
										lastCardMeld = true;
										offsetX = offsetXMeld;
									}

									//first card
									if (i === 0) {
										offsetX = 0;
									}

									currentX = currentX + offsetX;
									cardUI.targetX = pileX + (cardWidth / 2) + currentX;
									cardUI.targetY = pileY;
									if (cardUI.isSelected) {
										cardUI.targetY += pileLayout.selectedOffsetY || 0;
									}
								}
							}

							break;
						case 'center':
							{
								const pilecount = pileCardUIs.length;
								const pileX = pileLayout.x;
								const pileY = pileLayout.y;
								const cardWidth = pileLayout.width || 0;
								//let cardHeight = pileLayout.height;
								//let offsetX = pileLayout.offsetX;
								//let offsetY = pileLayout.offsetY;
								//let offsetR = pileLayout.offsetR;
								const pileWidth = pileLayout.pileWidth;
								let currentX = 0;
								let offsetX = 0;

								pileCardUIs.sort(function (a, b) {
									return (a.zIndex || 0) - (b.zIndex || 0);
								});
								for (let i = 0; i < pilecount; i++) {//const cardUI of pileCardUIs) {
									const cardUI = pileCardUIs[i];

									const remainingWidth = pileWidth - cardWidth - currentX;
									const remainingCards = pilecount - i;

									offsetX = remainingWidth / remainingCards;
									//if (cardUI.meld > 0) offsetX = offsetXMeld;
									if (i === 0) {
										offsetX = 0;
									}

									currentX = currentX + offsetX;
									cardUI.targetX = pileX + (cardWidth / 2) + currentX;
									cardUI.targetY = pileY;
									cardUI.meld = 0;
									if (cardUI.isSelected) {
										cardUI.targetY += pileLayout.selectedOffsetY || 0;
									}
								}
							}

							break;
						// case "center":
						//     for (const cardUI of pileCardUIs) {
						//         let pilecount = pileCardUIs.length;
						//         let pilez = cardUI.zIndex;
						//         let offsetX = pileLayout.offsetX;
						//         let offsetY = pileLayout.offsetY;
						//         let count = pilecount - 1;
						//         let maxWidth = pileLayout.maxWidth;
						//         if (maxWidth && offsetX * pilecount > maxWidth) {
						//             offsetX = maxWidth / pilecount;
						//         }
						//         cardUI.targetX = pileLayout.x + (pilez * offsetX) - (count * offsetX / 2);
						//         cardUI.targetY = pileLayout.y + (pilez * offsetY) - (count * offsetY / 2);
						//         if (cardUI.isSelected) cardUI.targetY += pileLayout.selectedOffsetY || 0;
						//         pileLayout.offsetR = pileLayout.offsetR || 0;
						//         cardUI.rotation = (pileLayout.r || 0) + (pilez * pileLayout.offsetR) - (count * pileLayout.offsetR / 2);
						//     }
						//     break;
						default:
							for (const cardUI of pileCardUIs) {
								const pilez = cardUI.zIndex;
								cardUI.targetX = pileLayout.x + (pilez * (pileLayout.offsetX));
								cardUI.targetY = pileLayout.y + (pilez * (pileLayout.offsetY));
								if (cardUI.isSelected) {
									cardUI.targetY += pileLayout.selectedOffsetY || 0;
								}

								cardUI.rotation = pileLayout.r || 0;

							}
					}

				}
			}

			//add tweening if needed
			for (const cardUI of pileCardUIs) {
				cardUI.updateTexture();
				if (cardUI.x != cardUI.targetX || cardUI.y != cardUI.targetY) {
					//cardUI.x = cardUI.targetX ;
					//cardUI.y = cardUI.targetY;

					cardUI.tween = new TWEEN.Tween(cardUI, this.tweenGroup);
					cardUI.tween.easing(TWEEN.Easing.Exponential.Out);
					cardUI.tween.to({
						x: cardUI.targetX,
						y: cardUI.targetY,
					}, 300);
					cardUI.tween.start();
				}
			}

		}

		this.children.sort(function (a, b) {
			return (a.zIndex || 0) - (b.zIndex || 0);
		});

		this.isdirtyCardsPos = false;

	}

	updateCardsPos1(cards, layout) {
		//todo: could pass in state and pile could have different layout per state.

		//clear tweens
		this.tweenGroup.removeAll();

		//done://todo: optimize to only be called once and not for every card moved - could use - addOnce(fn, context, priority)PIXI.ticker.Ticker Ticker.js - Add a handler for the tick event which is only execute once.
		//done://note: or a flag for the game loop to do on dirty

		//note: could loop through cards and if no cardUI found create it
		//note: better to have a single batch update ui as z is need to be know
		//note:  but then again it is known from the model

		//todo: optimize - either move single card or all cards or pile update
		//todo: optimize - card lookup using hash or saving card reference on cardUI.
		//update cardUIs from model
		for (let i = 0; i < this.cardUIs.length; i++) {
			const cardUI = this.cardUIs[i];
			//let cardModel = cardUI.card; //note: might not want to not have reference to model on card
			let cardModel = null;
			for (let j = 0; j < cards.length; j++) {
				const card = cards[j];
				if (cardUI.id === card.id) {
					cardModel = card;
					break;
				}
			}

			if (!cardModel) {
				continue;
			}

			//update from model
			cardUI.pile = cardModel.pile; //update from model
			cardUI.showfront = cardModel.showfront; //todo: optimize updating texture only if needed
			cardUI.zIndex = cardModel.pilez || cardModel.order;
			cardUI.isSelected = cardModel.isSelected;
			cardUI.meld = cardModel.meld;
		}

		//todo: could loop by piles or at least 
		for (let i = 0; i < this.cardUIs.length; i++) {
			const cardUI = this.cardUIs[i];
			const pile = cardUI.pile;
			//update based on pile layout
			if (typeof layout[pile] !== 'undefined') {
				const pileLayout = layout[pile];
				if (pileLayout !== undefined) {
					if (pileLayout.showfront !== undefined) {
						cardUI.showfront = pileLayout.showfront;
					}

					cardUI.updateTexture();

					let pilez = cardUI.zIndex;
					//if random order then randomize the order the same
					if (pileLayout.randomZOrder === true) {
						const pileCardUIs = this.getPile(this.cardUIs, pile); //todo: optimize, this should not be called on ever card, but on each pile
						pileCardUIs.sort(function (a, b) {
							return a.randomId - b.randomId;
						}); //todo: optimize, this should not be called on ever card, but on each pile
						pilez = pileCardUIs.indexOf(cardUI);
					}

					const offsetZ = pileLayout.offsetZ || 0;
					cardUI.zIndex = pilez + offsetZ;
					if (pileLayout.center === true) {
						const pilecount = this.getPile(cards, pile).length; //todo: optimize, this should not be called on ever card, but on each pile
						let offsetX = pileLayout.offsetX;
						const offsetY = pileLayout.offsetY;
						const count = pilecount - 1;
						const maxWidth = pileLayout.maxWidth;
						if (maxWidth && offsetX * pilecount > maxWidth) {
							offsetX = maxWidth / pilecount;
						}

						cardUI.targetX = pileLayout.x + (pilez * offsetX) - (count * offsetX / 2);
						cardUI.targetY = pileLayout.y + (pilez * offsetY) - (count * offsetY / 2);
						if (cardUI.isSelected) {
							cardUI.targetY += pileLayout.selectedOffsetY || 0;
						}

						pileLayout.offsetR = pileLayout.offsetR || 0;
						cardUI.rotation = (pileLayout.r || 0) + (pilez * pileLayout.offsetR) - (count * pileLayout.offsetR / 2);
					} else {
						cardUI.targetX = pileLayout.x + (pilez * (pileLayout.offsetX));
						cardUI.targetY = pileLayout.y + (pilez * (pileLayout.offsetY));
						if (cardUI.isSelected) {
							cardUI.targetY += pileLayout.selectedOffsetY || 0;
						}

						cardUI.rotation = pileLayout.r || 0;
					}

					if (pileLayout.width) {
						cardUI.width = pileLayout.width;
					}

					if (pileLayout.height) {
						cardUI.height = pileLayout.height;
					}

					if (pileLayout.scale) {
						cardUI.scale.x = cardUI.scale.y = pileLayout.scale || 1;
					}
				}
			}

			//add tweening if needed
			if (cardUI.x != cardUI.targetX || cardUI.y != cardUI.targetY) {
				// cardUI.x = cardUI.targetX ;
				// cardUI.y = cardUI.targetY;
				cardUI.tween.to({
					x: cardUI.targetX,
					y: cardUI.targetY,
				}, 300);
				//cardUI.tween.to({ x: cardUI.targetX, y: cardUI.targetY }, 600);
				cardUI.tween.start();
			}
		}

		//http://pixijs.io/examples/#/layers/zorder.js

		//todo: optimize to only be called once - could use - addOnce(fn, context, priority)PIXI.ticker.Ticker Ticker.js - Add a handler for the tick event which is only execute once.
		//note: or a flag for the game loop to do on dirty
		//update z order for sprites
		this.children.sort(function (a, b) {
			return (a.zIndex || 0) - (b.zIndex || 0);
		});

		this.isdirtyCardsPos = false;
		// this.isDirty = true;

		//this.validateCardLocationBug();
	}

	getPile(cards, pileName) {
		const pileCards = new Array();
		for (let i = 0; i < cards.length; i++) {
			const card = cards[i];
			if (card.pile === pileName) {
				pileCards.push(card);
			}
		}

		//pileCards = this.sortByKey(pileCards, "pilez");
		return pileCards;
	}

	sortByKey(array, key) {
		return array.sort(function (a, b) {
			const x = a[key];
			const y = b[key];
			return ((x < y) ? -1 : ((x > y) ? 1 : 0));
		});
	}
}
